import {useQuery} from '@tanstack/react-query';
import {useState} from 'react';
import {
  getDashboardData,
  DashboardDataResponse,
  downloadMonthlyRevenueReport,
} from '$api/finance/dashboard';
import {monthNames} from './constant';
import toast from '$utils/toast';
import {ToastType} from '$components/Toast/constant';

export function useDashboardData() {
  const {data, isLoading, isError} = useQuery<DashboardDataResponse>({
    queryKey: ['dashboard-data'],
    queryFn: getDashboardData,
  });
  return {
    isLoading,
    isError,
    data,
  };
}

export const useDownloadMonthlyRevenue = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (selectedMonth: string) => {
    if (!selectedMonth) {
      toast(ToastType.Error, 'Download Error', 'Please select a month first');
      return;
    }

    setIsDownloading(true);
    try {
      const [monthName, year] = selectedMonth.split(' ');
      const monthIndex = monthNames.indexOf(monthName);
      if (monthIndex === -1) {
        throw new Error('Invalid month format');
      }

      const date = `${year}-${monthIndex + 1}-1`;

      const format = 'pdf';
      const reportBlob = await downloadMonthlyRevenueReport(date, format);

      const url = window.URL.createObjectURL(reportBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `monthly_revenue_report_${selectedMonth.replace(' ', '_')}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast(
        ToastType.Success,
        'Download success',
        `Monthly revenue report for ${selectedMonth} downloaded successfully`
      );
    } catch (error) {
      console.error('Error downloading monthly revenue report:', error);
      toast(
        ToastType.Error,
        'Download error',
        'Failed to download monthly revenue report'
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    isDownloading,
    handleDownload,
  };
};
